import React from 'react';
import ServiceLandingPage, { ServiceConfig } from '../components/ServiceLandingPage';

const config: ServiceConfig = {
  name: 'Software Repair',
  icon: '💻',
  tagline: 'Phone stuck, slow or crashing? Software issues fixed at your doorstep.',
  description: 'Is your phone stuck on boot, running slow, showing errors, or not responding? Minto\'s technicians handle software repairs including OS reinstall, virus/malware removal, factory reset with backup, and app fixes — all at your doorstep across Mumbai. No data loss where avoidable.',
  price: '299',
  warranty: '30-Day',
  benefits: [
    { icon: '🏠', title: 'Doorstep Service', desc: 'Technician comes to your location — home, office or café.' },
    { icon: '⚡', title: 'Same Day Service', desc: 'Book before 6 PM and get software issues resolved today.' },
    { icon: '🛡️', title: '30-Day Warranty', desc: 'All software repairs backed by 30 days warranty.' },
    { icon: '💾', title: 'Data Backup First', desc: 'We always attempt to back up your data before any software work.' },
    { icon: '🔒', title: 'Virus Removal', desc: 'Malware, adware, and virus removal for a clean phone.' },
    { icon: '💰', title: 'Transparent Pricing', desc: 'Price confirmed before we begin. No surprise charges.' },
  ],
  brands: ['iPhone', 'Samsung', 'OnePlus', 'Vivo', 'Oppo', 'Realme', 'Motorola', 'Xiaomi', 'Nothing', 'Google Pixel', 'Honor', 'Asus'],
  faqs: [
    { q: 'Will I lose my data during software repair?', a: 'We always try to back up your data first. If a factory reset is needed, we\'ll inform you before proceeding.' },
    { q: 'My phone is stuck on the logo — can you fix it?', a: 'Yes, boot loop and stuck logo issues are common and usually fixable without data loss.' },
    { q: 'Can you fix an iPhone that\'s disabled or locked?', a: 'We can help with iCloud lock removal in certain cases. Contact us to discuss your specific situation.' },
    { q: 'Which areas in Mumbai do you cover?', a: 'We cover Andheri, Bandra, Dadar, Lower Parel, Borivali, Malad, Goregaon, Vile Parle, Ghatkopar, Kurla, Thane, Chembur and Navi Mumbai.' },
  ],
};

const SoftwareRepairPage: React.FC = () => <ServiceLandingPage config={config} />;
export default SoftwareRepairPage;
